import React from 'react';
import CardWithAction from '../CardWithAction';
import { Container } from './styles';
const ContainerCardsWithAction = ({ items, theme }) => {
  return (
    <Container>
      {items.length > 0 &&
        items.map(({ title, subtitle, imgSrc, buttonText, onClickButton }) => (
          <CardWithAction
            key={title}
            title={title}
            subtitle={subtitle}
            imgSrc={imgSrc}
            buttonText={buttonText}
            onClickButton={onClickButton}
            theme={theme}
          />
        ))}
    </Container>
  );
};
export default ContainerCardsWithAction;
